import { DownOutlined, LogoutOutlined, SafetyOutlined } from '@ant-design/icons'
import { Dropdown, MenuProps, Space, Typography } from 'antd'

import { logoutApi } from '@eastcoal/api/auth/auth/logout'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { useNavigate } from '@eastcoal/router/exports/react-router'
import { UserAvator } from '@eastcoal/shared/components/UserAvatar'

export const HeaderAvatar = () => {
  const { user } = useAuthStore(state => pick(state, ['user']))

  const navigate = useNavigate()

  const items: MenuProps['items'] = [
    {
      key: 'security',
      label: '账号安全',
      icon: <SafetyOutlined />,
      async onClick() {
        navigate('/security')
      }
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: '退出',
      icon: <LogoutOutlined />,
      async onClick() {
        try {
          // 忽略错误
          await logoutApi(undefined, { silence: true })
        } finally {
          navigate('/login')
        }
      }
    }
  ]

  return (
    <Dropdown menu={{ items }}>
      <Typography.Link>
        <Space>
          <UserAvator size='small' />
          <span>{user.name}</span>
          <DownOutlined />
        </Space>
      </Typography.Link>
    </Dropdown>
  )
}
